import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'inicialesNombre',
})
export class InicialesNombrePipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): string {
    if (typeof value !== 'string' || !value.trim()) return '';
    const partes = value.trim().split(/\s+/);
    if (partes.length === 1) {
      return partes[0][0].toUpperCase();
    }
    // Tomar la inicial del primer y segundo elemento (nombre y primer apellido)
    return (partes[0][0] || '').toUpperCase() + (partes[1][0] || '').toUpperCase();
  }
}
